import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CurrencyDefinitionType } from 'data/Instrument/types'

export type PaymentCurrenciesState = {
  data: CurrencyDefinitionType[]
  fetching: boolean
  hasError: boolean
}

export const initialState: PaymentCurrenciesState = {
  data: [],
  fetching: false,
  hasError: false
}

const paymentCurrenciesSlice = createSlice({
  initialState,
  name: 'currencies',
  reducers: {
    error(state) {
      state.fetching = false
      state.hasError = true
    },
    fetch(state) {
      state.fetching = true
    },
    setData(state, action: PayloadAction<CurrencyDefinitionType[]>) {
      state.fetching = false
      state.data = action.payload
    }
  }
})

export const { actions } = paymentCurrenciesSlice
export default paymentCurrenciesSlice.reducer
